import { ICms_Category, Cms_CategoryResponseType } from './staff.types';
export default class Cms_Category implements ICms_Category {
    id: number | null;
    name: string;
    constructor(data: Cms_CategoryResponseType) {
        this.id = data.id;
        this.name = data.name;
    }
}
